export function formatNullableNumber(
  value: number | null | undefined,
  digits = 1,
  suffix = "",
): string {
  return typeof value === "number" && Number.isFinite(value)
    ? `${value.toFixed(digits)}${suffix}`
    : "n/a";
}
